export default __webpack_public_path__ + "static/media/H4003.ce2e8274.mp3";